import React from 'react';
import {
  Flex,
  FormControl,
  FormLabel,
  Input as ChakraInput,
  FormErrorMessage,
} from '@chakra-ui/react';
import { Controller, Control, FieldValues } from 'react-hook-form';

interface InputProps<T extends FieldValues> {
  name: string;
  control: Control<T>;
  label: string;
  rules?: object;
  type?: string;
  error?: any;
}

const Input = <T extends FieldValues>({
  name,
  control,
  label,
  rules,
  type = 'text',
  error,
}: InputProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue=""
      render={props => (
        <Flex
          flexDir={['column', 'row']}
          justify={['flex-start', 'space-between']}
          align={['flex-start', 'center']}
          mb="15px"
        >
          <FormLabel
              fontWeight={400}
              p={['0 0 5px 0', '0']}
              margin={['unset', '0 10px 0 0']}
              w="100%"
              maxW={['100%', '500px']}
              color="brand.fontColors.primary"
              htmlFor={`${props.value}`}
            >
              {label}
            </FormLabel>
        <FormControl isInvalid={!!error} mb={4}>
          <ChakraInput
            id={`${props.value}`}
            size="lg"
            maxW="400px"
            borderRadius="0px"
            bg="#E4EAEB"
            _hover={{ bg: '#F4F8F8' }}
            type={type}
            max={type === 'date' ? new Date().toISOString().split('T')[0] : undefined}
            {...props}
            pattern={type === 'number' ? '^\\d+$' : undefined}
            onBeforeInput={(e: any) => {
              
              if (/\D/.test(e.data) && type === 'number') {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const clipboardData = e.clipboardData || (window as any).clipboardData;
              const pastedData = clipboardData.getData('text');
              if (type === 'number') {
                
                  const cleanedValue = pastedData.replace(/\D/g, '');
                  if (cleanedValue !== pastedData) {
                    e.preventDefault();
                    props.onChange(cleanedValue);
                  }
                
              }
            }}
          />
          <FormErrorMessage>
            {error?.message}
          </FormErrorMessage>
        </FormControl>
        </Flex>
      )}
    />
  );
};

export default Input;
